import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  gap: 1rem;
  text-align: center;
`;

const Icon = styled.div`
  font-size: 3rem;
`;

const Message = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1rem;
`;

interface EmptyStateProps {
  message?: string;
  icon?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  message = "No products found",
  icon = "📦",
}) => (
  <Wrapper>
    <Icon>{icon}</Icon>
    <Message>{message}</Message>
  </Wrapper>
);

export default EmptyState;
